<div class="empty-state" role="status">
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>

  <span class="empty-state__text">{{ titleKey | eCaseTranslate }}</span>
  <span class="empty-state__hint" *ngIf="hintKey">{{ hintKey | eCaseTranslate }}</span>

  <div class="empty-state__actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
